module.exports = __webpack_public_path__ + "static/serverrack-7861dff9479fd12d153520de753a764c.png";